module.exports = __webpack_public_path__ + "img/fleumatico.7469cc0b.svg";